// extracted by mini-css-extract-plugin
module.exports = {"hover":"Tooltip_hover__3UWp4"};